import React, { useState } from 'react';
import './SupportForm.css'; // Import CSS file for styling
import TranslateText from '../../translation/TranslateText'; // Adjust the import path as needed

function SupportTicketForm() {
  const [focusedInputs, setFocusedInputs] = useState({
    name: false,
    email: false,
    phoneNumber: false,
    reason: false,
    orderNumber: false
  });

  const handleFocus = (fieldName) => {
    setFocusedInputs({ ...focusedInputs, [fieldName]: true });
  };

  const handleBlur = (fieldName) => {
    setFocusedInputs({ ...focusedInputs, [fieldName]: false });
  };

  return (
    <section className='login-section addMore' style={{
      backgroundImage: 'linear-gradient(to bottom right, #9D00B6, #ed76ff)' }}>
      <div className="container">
        <div className="login-box">
          <h2 className='ticket'><TranslateText text="Support Ticket" /></h2>
          <form>
            <div className="double-sided-form">
              <div className={`user-box ${focusedInputs.name ? 'focused' : ''}`}>
                <input
                  type="text"
                  name="name"
                  required
                  onFocus={() => handleFocus('name')}
                  onBlur={() => handleBlur('name')}
                />
                <label><TranslateText text="**Name" /></label>
              </div>
              <div className={`user-box ${focusedInputs.email ? 'focused' : ''}`}>
                <input
                  type="email"
                  name="email"
                  required
                  onFocus={() => handleFocus('email')}
                  onBlur={() => handleBlur('email')}
                />
                <label><TranslateText text="**Email" /></label>
              </div>
              <div className={`user-box ${focusedInputs.phoneNumber ? 'focused' : ''}`}>
                <input
                  type="tel"
                  name="phoneNumber"
                  required
                  onFocus={() => handleFocus('phoneNumber')}
                  onBlur={() => handleBlur('phoneNumber')}
                />
                <label><TranslateText text="**Phone Number" /></label>
              </div>
              <div className={`user-box ${focusedInputs.reason ? 'focused' : ''}`}>
                <input
                  type="text"
                  name="reason"
                  required
                  onFocus={() => handleFocus('reason')}
                  onBlur={() => handleBlur('reason')}
                />
                <label><TranslateText text="**What is the reason for your ticket?" /></label>
              </div>
              <div className={`user-box ${focusedInputs.orderNumber ? 'focused' : ''}`}>
                <input
                  type="text"
                  name="orderNumber"
                  required
                  onFocus={() => handleFocus('orderNumber')}
                  onBlur={() => handleBlur('orderNumber')}
                />
                <label><TranslateText text="**What is your order number? (If you know it.)" /></label>
              </div>
              
              <div className='report-div'>
                <span className='reporting'>
                  <TranslateText text="***IF YOU ARE REPORTING A NON-POSTING ISSUE OR CHECKING ON A TRADELINE POSTING STATUS, PLEASE COMPLETE THE INFO BELOW TO EXPEDITE YOUR REQUEST AND AVOID DELAYS!***" />
                </span>
              </div>

              <div className={`user-box ${focusedInputs.name ? 'focused' : ''}`}>
                <input
                  type="text"
                  name="name"
                  required
                  onFocus={() => handleFocus('name')}
                  onBlur={() => handleBlur('name')}
                />
                <label><TranslateText text="*What tradeline(s) are you inquiring about? Name and/or credit limit." /></label>
              </div>
              <div className={`user-box ${focusedInputs.email ? 'focused' : ''}`}>
                <input
                  type="email"
                  name="email"
                  required
                  onFocus={() => handleFocus('email')}
                  onBlur={() => handleBlur('email')}
                />
                <label><TranslateText text="*Please enter your DATE OF BIRTH" /></label>
              </div>
 
              <div className={` input-special bigger user-box ${focusedInputs.reason ? 'focused' : ''}`}>
                <input
                  type="text"
                  name="reason"
                  required
                  onFocus={() => handleFocus('reason')}
                  onBlur={() => handleBlur('reason')}
                />
                <label>
                  <TranslateText text="*Name of credit monitoring service. You must use Credit Check Total, Equifax.com or a PAID 3 bureau service. 
                Note: Credit Karma is NOT accepted for non-posting issues." />
                </label>
              </div>
              <div className={`user-box ${focusedInputs.orderNumber ? 'focused' : ''}`}>
                <input
                  type="text"
                  name="orderNumber"
                  required
                  onFocus={() => handleFocus('orderNumber')}
                  onBlur={() => handleBlur('orderNumber')}
                />
                <label><TranslateText text="*Username and password (required for non-posting issues)" /></label>
              </div>
            </div>
            <button type="submit" className="submit-btn">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <TranslateText text="Submit" />
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}

export default SupportTicketForm;









// import React, { useState } from 'react';
// import './SupportForm.css'; // Import CSS file for styling

// function SupportTicketForm() {
//   const [focusedInputs, setFocusedInputs] = useState({
//     name: false,
//     email: false,
//     phoneNumber: false,
//     reason: false,
//     orderNumber: false
//   });

//   const handleFocus = (fieldName) => {
//     setFocusedInputs({ ...focusedInputs, [fieldName]: true });
//   };

//   const handleBlur = (fieldName) => {
//     setFocusedInputs({ ...focusedInputs, [fieldName]: false });
//   };

//   return (
//     <section className='login-section addMore' style={{
//       backgroundImage: 'linear-gradient(to bottom right, #9D00B6, #ed76ff)' }}>
//       <div className="container">
//         <div className="login-box">
//           <h2 className='ticket'>Support Ticket</h2>
//           <form>
//             <div className="double-sided-form">
//               <div className={`user-box ${focusedInputs.name ? 'focused' : ''}`}>
//                 <input
//                   type="text"
//                   name="name"
//                   required
//                   onFocus={() => handleFocus('name')}
//                   onBlur={() => handleBlur('name')}
//                 />
//                 <label>**Name</label>
//               </div>
//               <div className={`user-box ${focusedInputs.email ? 'focused' : ''}`}>
//               <input
//                   type="text"
//                   name="name"
//                   required
//                   onFocus={() => handleFocus('name')}
//                   onBlur={() => handleBlur('name')}
//                 />
//                 {/* TODO: <input
//                   type="email"
//                   name="email"
//                   required
//                   onFocus={() => handleFocus('email')}
//                   onBlur={() => handleBlur('email')}
//                 /> */}
//                 <label>**Email</label>
//               </div>
//               <div className={`user-box ${focusedInputs.phoneNumber ? 'focused' : ''}`}>
//                 <input
//                   type="tel"
//                   name="phoneNumber"
//                   required
//                   onFocus={() => handleFocus('phoneNumber')}
//                   onBlur={() => handleBlur('phoneNumber')}
//                 />
//                 <label>**Phone Number</label>
//               </div>
//               <div className={`user-box ${focusedInputs.reason ? 'focused' : ''}`}>
//                 <input
//                   type="text"
//                   name="reason"
//                   required
//                   onFocus={() => handleFocus('reason')}
//                   onBlur={() => handleBlur('reason')}
//                 />
//                 <label>**What is the reason for your ticket?</label>
//               </div>
//               <div className={`user-box ${focusedInputs.orderNumber ? 'focused' : ''}`}>
//                 <input
//                   type="text"
//                   name="orderNumber"
//                   required
//                   onFocus={() => handleFocus('orderNumber')}
//                   onBlur={() => handleBlur('orderNumber')}
//                 />
//                 <label>**What is your order number? (If you know it.)</label>
//               </div>
              
//               <div className='report-div'><span className='reporting' >***IF YOU ARE REPORTING A NON-POSTING ISSUE OR CHECKING ON A TRADELINE POSTING STATUS, PLEASE COMPLETE THE INFO BELOW TO EXPEDITE YOUR REQUEST AND AVOID DELAYS!***</span></div>

//               <div className={`user-box ${focusedInputs.name ? 'focused' : ''}`}>
//                 <input
//                   type="text"
//                   name="name"
//                   required
//                   onFocus={() => handleFocus('name')}
//                   onBlur={() => handleBlur('name')}
//                 />
//                 <label>*What tradeline(s) are you inquiring about? Name and/or credit limit.</label>
//               </div>
//               <div className={`user-box ${focusedInputs.email ? 'focused' : ''}`}>
//                 <input
//                   type="email"
//                   name="email"
//                   required
//                   onFocus={() => handleFocus('email')}
//                   onBlur={() => handleBlur('email')}
//                 />
//                 <label>*Please enter your DATE OF BIRTH</label>
//               </div>
 
//               <div className={` input-special bigger user-box ${focusedInputs.reason ? 'focused' : ''}`}>
//                 <input
//                   type="text"
//                   name="reason"
//                   required
//                   onFocus={() => handleFocus('reason')}
//                   onBlur={() => handleBlur('reason')}
                  
//                 />
//                 <label >*Name of credit monitoring service. You must use Credit Check Total, Equifax.com or a PAID 3 bureau service. 
//                 Note: Credit Karma is NOT accepted for non-posting issues.</label>
//               </div>
//               <div className={`user-box ${focusedInputs.orderNumber ? 'focused' : ''}`}>
//                 <input
//                   type="text"
//                   name="orderNumber"
//                   required
//                   onFocus={() => handleFocus('orderNumber')}
//                   onBlur={() => handleBlur('orderNumber')}
//                 />
//                 <label>*Username and password (required for non-posting issues)</label>
//               </div>
              

//             </div>
//             <button type="submit" className="submit-btn">
//               <span></span>
//               <span></span>
//               <span></span>
//               <span></span>
//               Submit
//             </button>
//           </form>
//         </div>
//       </div>
//     </section>
//   );
// }

// export default SupportTicketForm;
